import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import BrowseByGame from "./sections/BrowseByGame";
import Tournament from "./sections/Tournament";
import CollectorCommunityFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <BrowseByGame />
      <Tournament />
      <CollectorCommunityFooter />
    </div>;
}